<template>
  <div>
    <div class="box-search">
      <div class="tabs-home-content mb-0 mt-sm-0 mt-3">
        <div class="box-search border">
          <div class="box-content content-2">
            <div class="icon-content">
              <i class="flaticon-bold-magnifier"></i>
            </div>
            <div class="input-content">
              <div class="d-block">
                <el-select
                  class="selectpers"
                  id="search-docuemnt"
                  name="search-docuemnt"
                  filterable
                  remote
                  reserve-keyword
                  :remote-method="getDocuemetsOptions"
                  @change="selectDocument"
                  :loading="loading"
                  v-model="simpleSearch"
                  placeholder="Search"
                  no-data-text="Not Found"
                  automatic-dropdown
                  ref="search"
                  clearable
                >
                  <el-option
                    v-for="(option, index) in documentsOptions"
                    :value="option._id"
                    :label="option.title"
                    :key="`${index}`"
                  >
                    <template>
                      <div class="items-product-search">
                        <div class="item-search">
                          <div class="content-p">
                            <span class="title-p">{{ option.title }}</span>
                            <span
                              class="country-price"
                              v-if="option.type === 'RELEASE'"
                            >
                              {{ option.type }}
                            </span>
                            <span class="country-price" v-else>
                              {{ option.type }} |
                              {{ option.module }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import endpoint from "../../../Commons/Services";
export default {
  name: "CardArticles",
  data() {
    return {
      documents: [],
      loading: true,
      simpleSearch: "",
      timeoutId: null
    };
  },
  methods: {
    async getDocuemetsOptions(search) {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(async () => {
        try {
          if (search !== "" && search.length > 2) {
            this.loading = true;
            let {
              data
            } = await endpoint.documents.services.getDocuemetsOptions(
              "INTERNAL",
              search,
              this.sesion.token
            );
            this.loading = false;
            if (data.code === 200) {
              let documents = data.data;
              this.documents = documents;
            } else {
              this.documents = [];
            }
          } else {
            this.documents = [];
          }
        } catch (error) {
          this.loading = false;
          this.documents = [];
        }
      }, 500);
    },
    async selectDocument(documentId) {
      let document = this.documentsOptions.find(
        document => document._id === documentId
      );
      if (document) {
        let modelSlug =
          document.type !== "RELEASE" ? document.module : "RELEASE";
        let articleSlug = document.slug;
        this.$router.push({
          path: this.getPathToArticle(modelSlug, articleSlug)
        });
      }
    },
    getPathToArticle(modelSlug, articleSlug) {
      if (modelSlug === "RELEASE") {
        return `/help/release/${articleSlug}`;
      } else {
        return `/help/${this.getSlugModule(modelSlug)}/${articleSlug}`;
      }
    },
    getSlugModule(module) {
      if (module === "ACCOUNT") {
        return "account";
      } else if (module === "DRIVER") {
        return "driver";
      } else if (module === "AREAS") {
        return "areas";
      } else if (module === "CUSTOMERS") {
        return "customers";
      } else if (module === "DESTINATIONS") {
        return "destinations";
      } else if (module === "GLOBAL") {
        return "global";
      } else if (module === "LOGS") {
        return "logs";
      } else if (module === "PROFILE") {
        return "profile";
      } else if (module === "RATES") {
        return "rates";
      } else if (module === "RESERVATIONS") {
        return "reservations";
      } else if (module === "USERS") {
        return "users";
      } else if (module === "VEHICLES") {
        return "vehicles";
      } else if (module === "SCHEDULE") {
        return "schedule";
      }
    }
  },
  computed: {
    ...mapGetters(["sesion"]),
    documentsOptions: function() {
      return this.documents.map(document => {
        return {
          _id: document._id,
          title: document.title,
          type: document.type,
          module: document.module,
          image:
            document.images.length > 0
              ? document.images[0]
              : "https://upcdn.io/FW25b8h/raw/documents/covers/rhomtrip-img-doc.png",
          short_description: document.short_description,
          slug: document.slug
        };
      });
    }
  },
  destroyed() {
    clearTimeout(this.timeoutId);
  }
};
</script>
